/**
 * Created by Daniela on 19/12/2016.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import { modeloGpsModuleName } from "../shared/data.service";
import {configuracaoModuleName, editRoute, newRoute} from "../../../shared/services/data.service";
import { ModeloGps } from "../shared/modelo-gps.model";
import { ModeloGpsApiService } from "../shared/modelo-gps-api.service";
import { ModeloGpsService } from "../shared/modelo-gps.service";
import { ModeloGpsNavigationService } from "../shared/modelo-gps-navigation.service";

import {RastreamentoService} from "../../shared/rastreamento.service";
import {rastreamentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./modelo-gps-form.component.html'),
    styles: [require('./modelo-gps-form.component.css')]
})
export class ModeloGpsFormComponent implements OnInit {
    modeloGpsModule:any = modeloGpsModuleName;
    formObject:any = new ModeloGps();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = rastreamentosModuleName;

    form:FormGroup;
    ativo = new FormControl('');
    modelo = new FormControl('', Validators.required);
    senha = new FormControl('');
    numero = new FormControl('');
    protocolo = new FormControl('');

    private returnToOtherForm:boolean = false;
    private otherForm:string;
    private responsModeloGps:any;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _modeloGpsService: ModeloGpsService,
        private _modeloGpsApiService: ModeloGpsApiService,
        private _modeloGpsNavigationService: ModeloGpsNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            modelo: this.modelo,
            senha: this.senha,
            numero: this.numero,
            protocolo: this.protocolo
        });
    }

    ngOnInit() {
        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.formObject.id) {
                this.onEditModeloGps(object);
            } else {
                this.onAddModeloGps(object);
            }
        }
    }

    private onAddModeloGps(object: ModeloGps) {
        this._modeloGpsApiService.onPost(object, this.onDone);
    }

    private onEditModeloGps(object: ModeloGps) {
        this._modeloGpsApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responsModeloGps = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum modelo de aparelho encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._modeloGpsApiService.onGetById(id, onDone);
    }

    private setModelToForm() {

    }

    private goToList() {
        this._modeloGpsService.clearSessionStorage();
        this._modeloGpsNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._modeloGpsService.getSessionStorage();
        this._modeloGpsService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            if (id) {
                this.setEditSession();
            } else {
                this.setNewSession();
            }
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.setModelToForm();
    }

    private setEditSession() {

    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
        this.setModelToForm();
    }

    private toLeaveHere() {
        this.goToList();
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/modelo-gps-form/modelo-gps-form.component.ts
 **/